const DEFAULT_EXPIRY_SKEW_SECONDS = 60;

function decodeBase64Url(value) {
  const base64 = String(value || '').replace(/-/g, '+').replace(/_/g, '/');
  const pad = base64.length % 4;
  const padded = pad ? `${base64}${'='.repeat(4 - pad)}` : base64;
  return window.atob(padded);
}

export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    return JSON.parse(decodeBase64Url(parts[1]));
  } catch {
    return null;
  }
}

export function getTokenExpiryMs(token) {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) {
    return null;
  }

  const exp = Number(payload.exp);
  if (!Number.isFinite(exp)) {
    return null;
  }

  return exp * 1000;
}

export function isTokenExpired(token, skewSeconds = DEFAULT_EXPIRY_SKEW_SECONDS) {
  if (!token) {
    return true;
  }

  const expiresAtMs = getTokenExpiryMs(token);
  if (expiresAtMs == null) {
    return true;
  }

  return expiresAtMs <= Date.now() + skewSeconds * 1000;
}

export function readResponseAuthHeader(response, headerName) {
  const headers = response?.headers;
  if (!headers) {
    return null;
  }

  const lower = headerName.toLowerCase();
  return (
    headers[lower] ||
    headers[headerName] ||
    (typeof headers.get === 'function' ? headers.get(headerName) || headers.get(lower) : null)
  );
}

export function storeAuthTokensFromResponse(response) {
  const accessToken = readResponseAuthHeader(response, 'X-Auth-Token');
  const refreshToken = readResponseAuthHeader(response, 'X-Auth-Refresh-Token');

  if (accessToken) {
    localStorage.setItem('Token', accessToken);
  }
  if (refreshToken) {
    localStorage.setItem('RefreshToken', refreshToken);
  }

  return { accessToken, refreshToken };
}
